import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import classNames from 'classnames';
import Image from 'gatsby-image';
import { isMobile } from '../lib/media-query';
var LEFT_ARROW_KEY = 37;
var RIGHT_ARROW_KEY = 39;
var ESCAPE_KEY = 27;
var Gallery = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(Gallery, _React$Component);
    function Gallery(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            activePhoto: -1
        };
        _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
        _this.renderPhoto = _this.renderPhoto.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = Gallery.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    };
    _proto.handleKeyDown = function handleKeyDown(event) {
        if (event.keyCode === ESCAPE_KEY) {
            this.setState({
                activePhoto: -1
            });
        }
        if (event.keyCode === LEFT_ARROW_KEY) {
            this.setState({
                activePhoto: this.goToIndex('previous')
            });
        }
        if (event.keyCode === RIGHT_ARROW_KEY) {
            this.setState({
                activePhoto: this.goToIndex('next')
            });
        }
    };
    _proto.goToIndex = function goToIndex(direction) {
        if (direction === 'previous') {
            return this.state.activePhoto === 0 ? this.props.images.edges.length - 1 : this.state.activePhoto - 1;
        }
        else if (direction === 'next') {
            return this.state.activePhoto === this.props.images.edges.length - 1 ? 0 : this.state.activePhoto + 1;
        }
        else {
            return this.state.activePhoto;
        }
    };
    _proto.renderArrow = function renderArrow(direction) {
        var _this2 = this;
        return /*#__PURE__*/ React.createElement("span", {
            className: classNames('gallery__arrow', {
                'gallery__arrow--left': direction === 'previous',
                'gallery__arrow--right': direction === 'next'
            }),
            onClick: function onClick() {
                return _this2.setState({
                    activePhoto: _this2.goToIndex(direction)
                });
            }
        }, direction === 'previous' ? 'Back' : 'Next');
    };
    _proto.renderPhoto = function renderPhoto(direction) {
        var _this3 = this;
        var sharedInactiveImageStyles = {
            opacity: '0.85',
            height: 'auto',
            maxHeight: '100vh',
            position: 'absolute',
            top: '50vh',
            left: '50vw',
            width: 'auto',
            maxWidth: '80vh'
        };
        var activeImageStyle = {
            height: 'auto',
            maxHeight: '100vh',
            position: 'absolute',
            top: '50vh',
            left: '50vw',
            width: 'auto',
            maxWidth: '95vw',
            transform: 'translate(-50%, -50%)',
            animation: 'fadeIn 0.5s'
        };
        var activeImageStyleLeft = Object.assign({}, sharedInactiveImageStyles, {
            transform: 'translate(-160vh, -50%) '
        });
        var activeImageStyleRight = Object.assign({}, sharedInactiveImageStyles, {
            transform: 'translate(80vh, -50%)'
        });
        function imageStyle() {
            if (direction === 'previous') {
                return activeImageStyleLeft;
            }
            else if (direction === 'next') {
                return activeImageStyleRight;
            }
            else {
                return activeImageStyle;
            }
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames('gallery__active__photo__container'),
            onClick: function onClick() {
                return _this3.onImageClick(direction);
            }
        }, /*#__PURE__*/ React.createElement(Image, {
            fluid: this.props.images.edges[this.goToIndex(direction)].node.childImageSharp.fluid,
            imgStyle: imageStyle()
        }));
    };
    _proto.onImageClick = function onImageClick(direction) {
        if (direction === 'next') {
            this.goToIndex('next');
        }
        else if (direction === 'previous') {
            this.goToIndex('previous');
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("section", {
            className: "gallery"
        }, this.renderActivePhoto, /*#__PURE__*/ React.createElement("div", {
            className: "gallery__container"
        }, this.renderGallery));
    };
    _createClass(Gallery, [{
            key: "hasActivePhoto",
            get: function get() {
                return this.state.activePhoto >= 0;
            }
        }, {
            key: "renderGallery",
            get: function get() {
                var _this4 = this;
                return this.props.images.edges.map(function (edge, index) {
                    return /*#__PURE__*/ React.createElement("figure", {
                        className: classNames('gallery__item', {
                            'gallery__item--vertical': edge.node.childImageSharp.fluid.aspectRatio < 1
                        }),
                        key: edge.node.id,
                        onClick: function onClick() {
                            return _this4.setState({
                                activePhoto: index
                            });
                        }
                    }, /*#__PURE__*/ React.createElement(Image, {
                        fluid: edge.node.childImageSharp.fluid
                    }));
                });
            }
        }, {
            key: "renderCloseButton",
            get: function get() {
                var _this5 = this;
                return /*#__PURE__*/ React.createElement("span", {
                    className: "gallery__active__close",
                    onClick: function onClick() {
                        return _this5.setState({
                            activePhoto: -1
                        });
                    }
                }, "Close");
            }
        }, {
            key: "renderActivePhoto",
            get: function get() {
                if (!this.hasActivePhoto || isMobile())
                    return null;
                return /*#__PURE__*/ React.createElement("section", {
                    className: "gallery__active"
                }, this.renderCloseButton, this.renderArrow('previous'), this.renderPhoto(), this.renderArrow('next'));
            }
        }]);
    return Gallery;
}(React.Component);
export { Gallery as default };
